import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
  Frame01: 'Frame01_TVConsole',
  Frame02: 'Frame02_StorageBox',
  Frame03: 'Frame03_MagazineRack',
  Frame04: 'Frame04_CatHouse',
  Frame05: 'Frame05_Bookshelf',
  Frame06: 'Frame06_Desk Shelf',
  Frame07: 'Frame07_CatTunnel',
  Frame08: 'Frame08_BlackRhino',
  Frame09: 'Frame09_PolarBear',
  Frame10: 'Frame10_SeaTurtle',
  Frame12: 'Frame12_Kibe',
  Frame13: 'Frame13_Tessellate',
  Frame14: 'Frame14_Twist',
  Frame15: 'Frame15_AlexCouchArmTable',
  Frame17: 'Frame17_Gio',
  Frame18: 'Frame18_KinokoTable',
  Frame19: 'Frame19_Magnuss',
  Frame20: 'Frame20_PostcardPlanter',
  Frame21: 'Frame21_SneakerRack',
  Frame22: 'Frame22_TheSoban',
  Frame23: 'Frame23_ToolBox',
  Frame24: 'Frame24_MobileScannerStand',
  Frame25: 'Frame25_TabletScannerStand',
  Frame26: 'Frame26_PetStairs',
  Frame27: 'Frame27_SoccerGoalPost',
	Frame28: 'Frame28_SoccerBoard',
	Frame29: 'Frame29_SixpackCarrier',
	Frame30: 'Frame30_TrophyTable',
	Frame31: 'Frame31_Megaphone',
  Frame32: 'Frame32_Mickey',
  Frame33: 'Frame33_Pluto'
};

export default {
  categoryKey: CategoryLists.Lifestyle.list.Frame,
  cover: {
    caption: 'LandingPage.theFrame',
    backgroundImage: require('../../cover_image/cover_storagebox2.png'),
    mobileCoverImage: require('../../cover_image/cover_storagebox2.png'),
    mainImage: {
      src: require('../../../assets/categories/frame.png'),
      pcSrc: require('../../../assets/categories/frame.png'),
    },
  },
  box: {
    title: 'ProductPage.selectDesign', //i18n
    list: [
      {
        key: ModelKey.Frame07,
        image: {
          mobile: require('../../thumbnail/cat_tunnel.png'),
          pc: require('../../thumbnail/cat_tunnel.png'),
        },
        title: 'ProductPage.CatTunnel', // i18n
        level: 2,
        minutes: 50,
        allowInches: [50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame05,
        image: {
          mobile: require('../../thumbnail/Book_shelf.png'),
          pc: require('../../thumbnail/Book_shelf.png'),
        },
        title: 'ProductPage.BookShelf', // i18n
        level: 2,
        minutes: 60,
        allowInches: [32, 43, 50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame06,
        image: {
          mobile: require('../../thumbnail/Desk_shelf.png'),
          pc: require('../../thumbnail/Desk_shelf.png'),
        },
        title: 'ProductPage.DeskShelf', // i18n
        level: 3,
        minutes: 80,
        allowInches: [43, 50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame02,
        image: {
          mobile: require('../../thumbnail/Storagebox.png'),
          pc: require('../../thumbnail/Storagebox.png'),
        },
        title: 'ProductPage.StorageBox', // i18n
        level: 3,
        minutes: 120,
        allowInches: [43, 50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame01,
        image: {
          mobile: require('../../thumbnail/tv_console.png'),
          pc: require('../../thumbnail/tv_console.png'),
        },
        title: 'ProductPage.tvConsole', // i18n
        level: 4,
        minutes: 180,
        allowInches: [65, 75+'↑'],
      },

      {
        key: ModelKey.Frame03,
        image: {
          mobile: require('../../thumbnail/Magazine_rack.png'),
          pc: require('../../thumbnail/Magazine_rack.png'),
        },
        title: 'ProductPage.MagazineRack', // i18n
        level: 4,
        minutes: 150,
        allowInches: [55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame04,
        image: {
          mobile: require('../../thumbnail/Cat_house.png'),
          pc: require('../../thumbnail/Cat_house.png'),
        },
        title: 'ProductPage.CatHouse', // i18n
        level: 5,
        minutes: 180,
        allowInches: [50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame24,
        image: {
          mobile: require('../../thumbnail/08_Mobile Scanner Stand.png'),
          pc: require('../../thumbnail/08_Mobile Scanner Stand.png'),
        },
        title: 'ProductPage.MobileScanner', // i18n
        level: 3,
        minutes: 120,
        allowInches: [55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame25,
        image: {
          mobile: require('../../thumbnail/09_Tablet Scanner Stand.png'),
          pc: require('../../thumbnail/09_Tablet Scanner Stand.png'),
        },
        title: 'ProductPage.TabletScanner', // i18n
        level: 3,
        minutes: 120,
        allowInches: [65, 75+'↑'],
      },
      {
        key: ModelKey.Frame26,
        image: {
          mobile: require('../../thumbnail/Pet Stairs.png'),
          pc: require('../../thumbnail/Pet Stairs.png'),
        },
        title: 'ProductPage.PetStairs', // i18n
        level: 4,
        minutes: 150,
        allowInches: [65, 75+'↑'],
      },
      
    ],
  },

  dezeenBox: {
    title: 'ProductPage.selectDesignDezeen', //i18n
    list: [
      {
        key: ModelKey.Frame09,
        image: {
          mobile: require('../../thumbnail/Endangered_Animals_bear.png'),
          pc: require('../../thumbnail/Endangered_Animals_bear.png'),
        },
        title: 'ProductPage.PolarBear', // i18n
        minutes: 55,
        allowInches: [65, 75+'↑'],
      },
      {
        key: ModelKey.Frame08,
        image: {
          mobile: require('../../thumbnail/Endangered_Animals_rhino.png'),
          pc: require('../../thumbnail/Endangered_Animals_rhino.png'),
        },
        title: 'ProductPage.BlackRhino', // i18n
        minutes: 55,
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame10,
        image: {
          mobile: require('../../thumbnail/Endangered_Animals_turtle.png'),
          pc: require('../../thumbnail/Endangered_Animals_turtle.png'),
        },
        title: 'ProductPage.SeaTurtle', // i18n
        minutes: 55,
        allowInches: [50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame12,
        image: {
          mobile: require('../../thumbnail/Kibe.png'),
          pc: require('../../thumbnail/Kibe.png'),
        },
        title: 'ProductPage.Kibe', // i18n
        minutes: 55,
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame13,
        image: {
          mobile: require('../../thumbnail/Tessellate.png'),
          pc: require('../../thumbnail/Tessellate.png'),
        },
        title: 'ProductPage.Tessellate', // i18n
        minutes: 55,
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame14,
        image: {
          mobile: require('../../thumbnail/Twist.png'),
          pc: require('../../thumbnail/Twist.png'),
        },
        title: 'ProductPage.Twist', // i18n
        minutes: 55,
        allowInches: [43, 50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame15,
        image: {
          mobile: require('../../thumbnail/Alex_couch_arm_table.png'),
          pc: require('../../thumbnail/Alex_couch_arm_table.png'),
        },
        title: 'ProductPage.AlexCouchArmTable', // i18n
        allowInches: [50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame17,
        image: {
          mobile: require('../../thumbnail/Gio.png'),
          pc: require('../../thumbnail/Gio.png'),
        },
        title: 'ProductPage.GIO', // i18n
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame18,
        image: {
          mobile: require('../../thumbnail/Kinokotable.png'),
          pc: require('../../thumbnail/Kinokotable.png'),
        },
        title: 'ProductPage.KinokoTable', // i18n
        allowInches: [50, 55, 65, 75+'↑'],
      },
      {
        key: ModelKey.Frame19,
        image: {
          mobile: require('../../thumbnail/Magnuss.png'),
          pc: require('../../thumbnail/Magnuss.png'),
        },
        title: 'ProductPage.Magnuss', // i18n
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame20,
        image: {
          mobile: require('../../thumbnail/Postcard_Planter_Series.png'),
          pc: require('../../thumbnail/Postcard_Planter_Series.png'),
        },
        title: 'ProductPage.PostCardPlanter', // i18n
        allowInches: [65, 75+'↑'],
      },
      {
        key: ModelKey.Frame21,
        image: {
          mobile: require('../../thumbnail/Sneaker_Rack.png'),
          pc: require('../../thumbnail/Sneaker_Rack.png'),
        },
        title: 'ProductPage.SneakerRack', // i18n
        allowInches: [75+'↑'],
      },
      {
        key: ModelKey.Frame22,
        image: {
          mobile: require('../../thumbnail/TheSoban.png'),
          pc: require('../../thumbnail/TheSoban.png'),
        },
        title: 'ProductPage.TheSoban', // i18n
        allowInches: [65, 75+'↑'],
      },
      {
        key: ModelKey.Frame23,
        image: {
          mobile: require('../../thumbnail/Toolbox.png'),
          pc: require('../../thumbnail/Toolbox.png'),
        },
        title: 'ProductPage.ToolBox', // i18n
        allowInches: [43, 50, 55, 65, 75+'↑'],
      },
    ],
  },
 
  worldcup:{
    title: 'ProductPage.selectDesignSoccer', //i18n
			list: [
			{
				key: ModelKey.Frame27,
				image: {
				mobile: require('../../thumbnail/soccergoalpost.png'),
				pc: require('../../thumbnail/soccergoalpost.png'),
				},
				title: 'ProductPage.soccergoalpost', // i18n
				allowInches: [55, 65, 75+'↑'],
			},	
			{
				key: ModelKey.Frame28,
				image: {
				mobile: require('../../thumbnail/soccerboard.png'),
				pc: require('../../thumbnail/soccerboard.png'),
				},
				title: 'ProductPage.soccerboard', // i18n
				allowInches: [75+'↑'],
			},	
			{
				key: ModelKey.Frame29,
				image: {
				mobile: require('../../thumbnail/sixpackcarrier.png'),
				pc: require('../../thumbnail/sixpackcarrier.png'),
				},
				title: 'ProductPage.sixpackcarrier', // i18n
				allowInches: [43, 50, 55, 65, 75+'↑'],
			},
			{
				key: ModelKey.Frame30,
				image: {
				mobile: require('../../thumbnail/trophytable.png'),
				pc: require('../../thumbnail/trophytable.png'),
				},
				title: 'ProductPage.trophytable', // i18n
				allowInches: [65,75+'↑'],
			},
			{
				key: ModelKey.Frame31,
				image: {
				mobile: require('../../thumbnail/megaphone.png'),
				pc: require('../../thumbnail/megaphone.png'),
				},
				title: 'ProductPage.megaphone', // i18n
				allowInches: [43, 50, 55, 65, 75+'↑'],
			},
		]
  },
  disney:{
    title: 'ProductPage.Disney', //i18n
    list: [
    {
      key: ModelKey.Frame32,
      image: {
        mobile: require('../../thumbnail/mickey.png'),
        pc: require('../../thumbnail/mickey.png'),
      },
      title: 'ProductPage.Mickey', // i18n
      allowInches: [55, 65, 75+'↑'],
    },
    {
      key: ModelKey.Frame33,
      image: {
        mobile: require('../../thumbnail/pluto.png'),
        pc: require('../../thumbnail/pluto.png'),
      },
      title: 'ProductPage.Pluto', // i18n
      allowInches: [55, 65, 75+'↑'],
    },
  ]
  },
  
  ModelKey: ModelKey,
};

export const Boxes = {
  [ModelKey.Frame01]: () => import('./tvconsole'),
  [ModelKey.Frame02]: () => import('./storagebox'),
  [ModelKey.Frame03]: () => import('./magazinerack'),
  [ModelKey.Frame04]: () => import('./cathouse'),
  [ModelKey.Frame05]: () => import('./bookshelf'),
  [ModelKey.Frame06]: () => import('./deskshelf'),
  [ModelKey.Frame07]: () => import('./cattunnel'),
  [ModelKey.Frame08]: () => import('./blackrhino'),
  [ModelKey.Frame09]: () => import('./polarbear'),
  [ModelKey.Frame10]: () => import('./turtle'),
  [ModelKey.Frame12]: () => import('./kibe'),
  [ModelKey.Frame13]: () => import('./tessellate'),
  [ModelKey.Frame14]: () => import('./twist'),
  [ModelKey.Frame15]: () => import('./armtable'),
  [ModelKey.Frame17]: () => import('./gio'),
  [ModelKey.Frame18]: () => import('./kinokotable'),
  [ModelKey.Frame19]: () => import('./magnuss'),
  [ModelKey.Frame20]: () => import('./postcard'),
  [ModelKey.Frame21]: () => import('./sneakerrack'),
  [ModelKey.Frame22]: () => import('./soban'),
  [ModelKey.Frame23]: () => import('./toolbox'),
  [ModelKey.Frame24]: () => import('./mobilescanner'),
  [ModelKey.Frame25]: () => import('./tabletscanner'),
  [ModelKey.Frame26]: () => import('./petstairs'),
  [ModelKey.Frame27]: () => import('./soccergoalpost'),	
	[ModelKey.Frame28]: () => import('./soccerboard'),	
	[ModelKey.Frame29]: () => import('./sixpackcarrier'),	
	[ModelKey.Frame30]: () => import('./trophytable'),	
	[ModelKey.Frame31]: () => import('./megaphone'),	
  [ModelKey.Frame32]: () => import('./mickey'),	
  [ModelKey.Frame33]: () => import('./pluto'),	
};


